// src/components/ProfileSubmitted.jsx
import React from "react";
import { useLocation, Link } from "react-router-dom";
import { Card, Typography, Button } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

export default function ProfileSubmitted() {
  const { state } = useLocation();
  const firstName = state?.firstName || state?.first_name || "Applicant";

  return (
    <div style={{ padding: "24px 16px", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#fbfbff" }}>
      {/* Responsive styling */}
      <style>{`
        .ps-card { max-width: 720px; width: 100%; border-radius: 12px; box-shadow: 0 12px 40px rgba(2,6,23,0.08); text-align: center; }
        .ps-card-body { padding: 28px; }
        .ps-check { font-size: 56px; color: var(--color-primary, #0D47FF); margin-bottom: 12px; line-height: 1; display: inline-block; }
        .ps-actions { margin-top: 18px; display: flex; gap: 12px; justify-content: center; align-items: center; flex-wrap: wrap; }
        .ps-actions a, .ps-actions .ant-btn { min-width: 140px; }

        /* Mobile adjustments */
        @media (max-width: 520px) {
          .ps-card-body { padding: 20px; }
          .ps-check { font-size: 44px; }
          .ps-actions { flex-direction: column; gap: 10px; }
          .ps-actions a, .ps-actions .ant-btn { width: 100%; min-width: 0; }
        }
      `}</style>

      <Card className="ps-card" bodyStyle={{ padding: 32 }} bordered={false}>
        <div className="ps-card-body">
          <div className="ps-check" aria-hidden>
            <CheckCircleOutlined />
          </div>

          <Title level={3} style={{ marginBottom: 8 }}>
            Thank you, {firstName}!
          </Title>

          <Paragraph style={{ color: "rgba(17,24,39,0.85)", fontSize: 16 }}>
            Your profile has been submitted successfully and is now under review by the admin team.
            We will notify you via email once your profile is approved.
          </Paragraph>

          <div className="ps-actions" role="group" aria-label="Post submission actions">
          
            {/* Primary button linking to PSG IAS site */}
            <Button
              type="primary"
              href="https://psgias.ac.in"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit PSG IAS website"
            >
              Visit PSG IAS Website
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
